import { createAlert } from "actions/alerts";

/**
* retreives all the bot topics
* @returns {Object}
*/
export function getBotTopicsAction() {
  return {
    CALL_API: {
      method: "get",
      endpoint: "/bot_topics/",
      types: ["GET_BOT_TOPICS_REQUEST", "GET_BOT_TOPICS_SUCCESS", "GET_BOT_TOPICS_FAILURE"]
    },
    dispatchCallbacks: [
      {
        request: createAlert,
        fireOnStatus: 400
      }
    ]
  };
}

/**
* adds a new bot topic
* @param {String} topic new topic to be added to the bot
* @returns {Object}
*/
export function addBotTopicAction(topic) {
  return {
    CALL_API: {
      method: "post",
      endpoint: "/bot_topics/",
      payload: { topic },
      types: ["ADD_BOT_TOPICS_REQUEST", "ADD_BOT_TOPICS_SUCCESS", "ADD_BOT_TOPICS_FAILURE"]
    },
    dispatchCallbacks: [
      {
        request: createAlert,
        fireOnStatus: 400
      }
    ]
  };
}

/**
* removes a bot topic
* @param {String} botTopicId id of topic to be removed
* @returns {Object}
*/
export function removeBotTopicAction(botTopicId) {
  return {
    CALL_API: {
      method: "delete",
      endpoint: `/bot_topics/${botTopicId}/`,
      types: ["DELETE_BOT_TOPICS_REQUEST", "DELETE_BOT_TOPICS_SUCCESS", "DELETE_BOT_TOPICS_FAILURE"]
    },
    dispatchCallbacks: [
      {
        request: createAlert,
        fireOnStatus: 400
      }
    ]
  };
}

/**
 * updates the users query and removes or addes errors
 * @param {String} query users query
 * @param {String} error error message being sent, defualt is null
 * @returns {Object}
 */
export function updateQueryAction(query, error = null) {
  return {
    type: "BOT_TOPICS_UPDATE_QUERY",
    query,
    error
  };
}
